import { useState, memo } from 'react';
import { DgtPdOrderReasonCode } from '../../models';

import SpinnerLoading from '../../components/SpinnerLoading'
import Alert from '../../components/Alert'

import { BsCheckCircle } from 'react-icons/bs'
import { MdError } from 'react-icons/md'

import { syncReason } from '../../apis'

export interface ReasonDetail {
  reasonCode: string
  reasonDescription: string
  quantity: string
}

export default memo(function AddLabOffice() {
  const [ orderIds, setOrderIds ] = useState<string>('')
  const [ showDialog, setShowDialog ] = useState<boolean>(false)
  const [ reasonCodes, setReasonCodes ] = useState<DgtPdOrderReasonCode[]>([])
  const [ loading, setLoading ] = useState<boolean>(false)
  const [ inValid, setInValid ] = useState<boolean>(false)
  
  const onSyncReason =  async () => {
    setLoading(true)
    setInValid(false)
    setShowDialog(false)
    const { success, new_components } = await syncReason([orderIds])
    
    if (success) {
      setOrderIds('')
      setReasonCodes(new_components.length > 0 ? new_components : [])
    }
    setShowDialog(true)
    setInValid(!success)
    setLoading(false)
  }

  return <div className="container px-3 space-y-4">
    <h4 className="font-bold">Sync Reason Code นอก BOM</h4>
    <div className={`grid grid-cols-1 gap-6 md:grid-cols-3`}>
      <div className='space-y-2'>
        <h6 className="italic underline ">กรอกเลข Order ที่ต้องการ <span className='font-light '>(กรอกได้ทีละ ORDER)</span></h6>
        <div className='flex items-center gap-2'>
          <input placeholder="Order No." className={` input-form-text`}
            value={orderIds}
            onChange={(e) => setOrderIds(e.currentTarget.value)}
          />
          <button
            className='w-32 btn-success'
            onClick={onSyncReason}
            disabled={loading || !orderIds}
            >Sync</button>
        </div>
        {loading ? <SpinnerLoading /> : null}
        <Alert
          onClose={() => setShowDialog(false)}
          show={showDialog}
          dismissible={true}
          variant={inValid ? 'danger' : 'success'}
          styles='mt-3'
        >
          <div className='flex gap-3'>{
            inValid ? <MdError color="red" size={25}/> : <BsCheckCircle color="green" size={25}/>
          } {inValid ? 'เกิดข้อผิดพลาดจากการ Sync กรุณาลองใหม่' : `Sync completed${reasonCodes.length > 0 ? ' : '+reasonCodes.length+' รายการ':' ไม่พบรายการใหม่'}`}
          </div>
        </Alert>
      </div>
      <div className='col-span-2 space-y-2'>
        <h6 className="italic font-light underline">ผลลัพธ์ Material ที่เพิ่มเข้ามาใหม่</h6>
        {reasonCodes.map((comp, idx) => {
          const selectedCodes = (comp?.reasonCodes ? JSON.parse(comp?.reasonCodes) : []) as ReasonDetail[]
          selectedCodes.sort((a, b) => a.reasonCode.localeCompare(b.reasonCode))
          return <div className="" key={comp.materialCode}>
            <h6 className='font-bold '>{idx+1}. {comp.materialCode} - {comp.materialDescription} (LabOffice = {comp.labOffice})</h6>
            {selectedCodes.map(code => <h6 className='pl-3 ' key={code.reasonCode}>- {code.reasonCode} {code.reasonDescription}</h6>)}
          </div>
        })}
      </div>
    </div>
  </div>
})